import React from 'react';
import Input from 'semantic-ui-react/dist/es/elements/Input';
import { Link } from 'react-router-dom';
import PaginatedList from '../../components/paginated-list/paginated-list';
import Modal from 'semantic-ui-react/dist/es/modules/Modal';
import { copyHtmlCommand } from '../../utils/library';
import {
  DEVICE_MOBILE,
  AWAITING_PAYMENT,
  ADD_PAYEE_URL,
  INDIVIDUAL,
  BANK_TRANSFER,
  BANK_METHODS,
  TRANSACTION_FINAL_STATES,
  PAYMENT_NOT_RECEIVED_STATE,
  LINKED_BANK_ACCOUNT,
  EGIRO_TEXT,
  DEEMED_PAID_SUB_STATUS_TEXT,
  PROCESSED_BY_CLEARING,
  SENT_TO_BENEFICIARY_BANK,
  PAID,
  APPROVED,
  CANCELLED,
  VERIFIED,
  FAILED,
  DELINKED,
  RECURRING_TRANSFER_DATA,
  UPCOMING,
  SCHEDULED,
  cashPickupUrl,
  workingHoursUrl,
  faqUrl,
  Recipient_Cash_Pickup_Details,
  TRANSACTION_HISTORY_PAGE_SIZE,
  HELP_CENTER,
  PAY_TO,
  PAYTO_TEXT
} from '../../utils/constants';
import DatePicker from 'react-datepicker';
import {
  TRANSACTION_FILTER_DATE_CRITERIA,
  TRANSACTION_FILTER_STATUS_CRITERIA
} from '../../utils/templates/transaction-history';
import 'react-datepicker/dist/react-datepicker.css';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import get from 'lodash/get';
import '../../screens/payee-list/payee-list.scss';
import moment from 'moment';
import { ModalFactory } from '../../components/modal/modal';
import {
  ModalContainer,
  ModalHeader,
  PaymentInfoContainer,
  MessageBox,
  VideoVerificationContainer,
  ModalSubtitle,
  PaidText
} from './styles';
import { compileTemplateNew, formatCurrencyToTwoDecimalPlaces } from '../library';
import CommonButton from '../../components/common-button/CommonButton';
import { TRANSACTION_HISTORY_CONST } from '../../screens/nium-forex/utils/constants';
import { GreyBox } from '../../screens/transaction-history/Styles';
import TransactionTimeLine from '../transaction-time-line';
import { handleRowSelected } from '../../screens/help-center/utils/Utils';
import {
  BLUE_WARNING_ICON,
  CANCEL_ICON,
  CLOSE,
  CLOSE_HEAVY_ICON,
  COPY_ICON,
  DOWN_CHEVRON_LIGHT_ICON,
  DOWNLOAD_RECEIPT_ICON,
  EDIT_ICON_MULTI_TXN_ICON,
  HAND_ICON,
  INFO_TIMELINE_ICON,
  INFORMATION_ICON_BLACK_BOLD_ICON,
  MAIL_ICON,
  MOBILE_ICON,
  NEW_ADD_REF_ICON,
  PINK_ARROW_ICON,
  SMALL_CALENDAR_PINK_ICON,
  TRANSACTION_SEARCH_CALENDER_LIGHT_ICON
} from '@Images';

const getCashTemplate = (cashPickUpTemplate) => {
  return (
    <div className="section cash-pickup">
      <div className="head popupIcon cash-head">
        <span>{cashPickUpTemplate[0]?.section}</span>
        <Popup
          trigger={
            <img alt="more-info" className="infoImg" src={INFORMATION_ICON_BLACK_BOLD_ICON} />
          }
          content="Share this ID with the beneficiary for cash pick-up."
          size="tiny"
          position="top center"
          wide={false}
        />
      </div>
      {cashPickUpTemplate[0]?.pickUpReferenceId?.length > 0 ? (
        <div className="key-value copy-button">
          {cashPickUpTemplate[0]?.pickUpReferenceId}
          <Popup
            id="iconButton"
            on="click"
            style={{ width: '90px', left: '-16px' }}
            hideOnScroll={true}
            trigger={
              <img
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  copyHtmlCommand(CashPickupMessage(cashPickUpTemplate[0]?.pickUpReferenceId));
                }}
                src={COPY_ICON}
                alt="copy"
              />
            }
            content={'Copied!!'}
          />
          <a
            href={`mailto:?subject=${encodeURIComponent(
              'Your cash is now ready for pick up!'
            )}&body=${emailContent(cashPickUpTemplate[0]?.pickUpReferenceId)}${faqUrl}`}
            id="gmail-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={MAIL_ICON} alt="gmail-icon" />
          </a>
        </div>
      ) : (
        <div className="key-value">{cashPickUpTemplate[0]?.fallbackText}</div>
      )}
    </div>
  );
};

const openTransactionTimelineModal = async (
  timelineData,
  timeline,
  timelineCMSLabels,
  transactionSummary,
  context,
  isTransactionNoPresentAndOpenFlag
) => {
  const handleRaiseNewTicket = async () => {
    await context?.props?.raiseNewTicket(true);
  };

  const handleOpenExistingTicketConversation = async () => {
    await context?.props?.setOpenConversationFlag(true);
  };

  await context?.props?.setHelpCenterSelectedTransaction(transactionSummary);

  //@ts-ignore
  await ModalFactory.builder(
    (onClose) => (
      <TransactionTimeLine
        timelineData={timelineData}
        timeline={timeline}
        transactionSummary={transactionSummary}
        timelineCMSLabels={timelineCMSLabels}
        onClose={onClose}
        context={context}
        handleRaiseNewTicket={handleRaiseNewTicket}
        handleOpenExistingTicketConversation={handleOpenExistingTicketConversation}
        isTransactionNoPresentAndOpenFlag={isTransactionNoPresentAndOpenFlag}
      />
    ),
    'send-money-bene-modal insta-modal center-modal',
    true
  );
};

const onRecurringTransferButtonClick = async (
  context,
  status_code,
  modalData,
  configId,
  transferId
) => {
  const value = status_code === UPCOMING ? 'pause' : 'cancel';
  await ModalFactory.builder(
    (onClose) => (
      <ModalContainer width={450} mobileWidth={360}>
        <div className="center">
          <img className="error-image" src={BLUE_WARNING_ICON} alt="error-icon" width={60} />
          <ModalHeader>{modalData?.modalHeading}</ModalHeader>
          <ModalSubtitle>{modalData?.modalContent}</ModalSubtitle>
          <CommonButton
            text={modalData?.modalPrimaryButton}
            width={418}
            height={46}
            onClick={() =>
              context.onPauseCancelRecurringTransfer(configId, transferId, onClose, value)
            }
          />
          <div className="btn-wrapper">
            <CommonButton
              text={modalData?.modalSecondaryButton}
              type="link"
              onClick={() => onClose(false)}
            />
          </div>
        </div>
      </ModalContainer>
    ),
    'insta-modal center-modal',
    true
  );
};

export const processTimelineData = (timelineArray = []) => {
  timelineArray.sort((item1, item2) => item1.sequence - item2.sequence);
  const lastActiveIndex = timelineArray.findLastIndex((item) => item.active);
  timelineArray.splice(0, lastActiveIndex);
  return timelineArray;
};

const getData = (status, recurringSavedAmount, destination_currency) => {
  const totalAmountSaved = Number(formatCurrencyToTwoDecimalPlaces(recurringSavedAmount));
  const SAVING_AMOUNT = `${totalAmountSaved} ${destination_currency}`;
  switch (status) {
    case UPCOMING:
      return {
        text: RECURRING_TRANSFER_DATA.upcomingData.text,
        recurringButtonText: RECURRING_TRANSFER_DATA.upcomingData.recurringButtonText,
        modalData: {
          modalHeading: RECURRING_TRANSFER_DATA.upcomingData.modalHeading,
          modalContent: RECURRING_TRANSFER_DATA.upcomingData.modalContent,
          modalPrimaryButton: RECURRING_TRANSFER_DATA.upcomingData.modalPrimaryButton,
          modalSecondaryButton: RECURRING_TRANSFER_DATA.upcomingData.modalSecondaryButton
        },
        icon: CANCEL_ICON
      };
    case SCHEDULED:
      return {
        text: RECURRING_TRANSFER_DATA.scheduledData.text,
        recurringButtonText: RECURRING_TRANSFER_DATA.scheduledData.recurringButtonText,
        modalData: {
          modalHeading: RECURRING_TRANSFER_DATA.scheduledData.modalHeading,
          modalContent: RECURRING_TRANSFER_DATA.scheduledData.modalContent,
          modalPrimaryButton: RECURRING_TRANSFER_DATA.scheduledData.modalPrimaryButton,
          modalSecondaryButton: RECURRING_TRANSFER_DATA.scheduledData.modalSecondaryButton
        },

        icon: CANCEL_ICON
      };
    default:
      return {
        text: (
          <PaidText>
            {totalAmountSaved <= 0
              ? RECURRING_TRANSFER_DATA.exchangeNotFluctuate
              : compileTemplateNew(RECURRING_TRANSFER_DATA.paidText, {
                  SAVING_AMOUNT
                })}
          </PaidText>
        )
      };
  }
};
const CashPickupMessage = (cashRefernceNumber) =>
  `
  <span>
  Hey there! Your cash is ready to be picked up from any of our available
    <a href=${cashPickupUrl} target="_blank" rel="noopener noreferrer">cash pick-up locations</a>
    during <a href=${workingHoursUrl}>working hours</a>.
    <br>
    To collect the cash, remember to carry along a valid original ID document and provide this cash pick-up reference ID:
    ${cashRefernceNumber}.
  </span>`;

const emailContent = (cashRefernceNumber) => {
  // eslint-disable-next-line max-len
  return `Hey there! Your cash is ready to be picked up from any of our available cash pick-up locations during working hours. To collect the cash, remember to carry along a valid original ID document and provide this cash pick-up reference ID: ${cashRefernceNumber}.%0D%0ATo know more about cash pick-up locations and valid IDs, browse our FAQs here: `;
};

export const openTimelineModal = async (
  context,
  lastSelectedTransactionId,
  transaction_id,
  transaction_number,
  timelineCMSLabels,
  transactionSummary,
  timelineData,
  timeline,
  isTransactionNoPresentAndOpenFlag
) => {
  const isHelpCenterRoute = context?.props?.location?.pathname === HELP_CENTER;

  if (isHelpCenterRoute) {
    const { timelineData, transactionSummary, timelineError } =
      (await context.getTransactionTimeline(transaction_id, transaction_number)) || {};
    if (timelineError) return;
    const timeline = processTimelineData(timelineData?.timeline || []);
    if (timeline) {
      openTransactionTimelineModal(
        timelineData,
        timeline,
        timelineCMSLabels,
        transactionSummary,
        context,
        isTransactionNoPresentAndOpenFlag
      );
    }
  } else {
    if (lastSelectedTransactionId !== '' && lastSelectedTransactionId !== transaction_id) {
      /*
      Usecase: If 2 transactions are opened and the user clicked TrackThisTransfer of other transaction
      We need updated data, need to call API and invoke modal with updated value
    */
      const { timelineData, transactionSummary, timelineError } =
        await context.getTransactionTimeline(transaction_id, transaction_number);
      if (timelineError) return;
      const timeline = processTimelineData(timelineData?.timeline || []);
      openTransactionTimelineModal(timelineData, timeline, timelineCMSLabels, transactionSummary);
    } else {
      openTransactionTimelineModal(timelineData, timeline, timelineCMSLabels, transactionSummary);
    }
  }
};

const handleRenderItem = (context, item, row) => {
  const isHelpCenterFlag = context?.props?.location?.pathname === HELP_CENTER;
  const isIndividual = get(context, 'props.account_type', '') === INDIVIDUAL;
  const { isNiumForexUser } = context?.props || '';
  const {
    timelineData,
    timelineCMSLabels,
    transactionSummary,
    lastSelectedTransactionId,
    timelineError,
    isRecurringTransferFlagEnabled,
    transactionSummaryArray
  } = context.state;

  const filteredTransactionSummaryItem = transactionSummaryArray?.find(
    (summaryItem) => summaryItem?.transaction_id === item?.transaction_id
  );

  const timeline = !isNiumForexUser && processTimelineData(timelineData?.timeline || []);
  const eddaDetails = filteredTransactionSummaryItem?.eddaDetails;
  const BANK_ACCOUNT_NUMBER = eddaDetails?.bankAccountNumber?.substr(
    eddaDetails?.bankAccountNumber.length - 5
  );
  const mandateDetails = filteredTransactionSummaryItem?.mandateDetails;
  const PAY_TO_BANK_ACCOUNT_NUMBER = mandateDetails?.accountNumber?.substr(
    eddaDetails?.bankAccountNumber.length - 5
  );

  if (!item)
    return (
      <div key={row} className="empty-row" style={{ height: context.state.emptyHeight }}>
        &nbsp;
      </div>
    );
  const {
    isExpanded,
    transaction_id,
    transaction_number,
    status_code,
    instarem_bank_account_code,
    instarem_bank_account_display_name,
    is_recurring = false,
    recurring_transfer_config_id,
    recurring_transfer_id,
    destination_currency,
    recurringSavedAmount,
    is_referral,
    pp_transaction_sub_status
  } = item;
  const { rowTemplate, detailTemplate, cashPickUpTemplate } = context.getDesktopTemplate({
    item,
    account_type: context.props.account_type
  });
  const showDeemedPaidMessage =
    status_code === PAID &&
    (pp_transaction_sub_status === PROCESSED_BY_CLEARING ||
      pp_transaction_sub_status === SENT_TO_BENEFICIARY_BANK);
  const hideTransferTracker =
    TRANSACTION_FINAL_STATES.includes(status_code) && !showDeemedPaidMessage;
  const { recurringButtonText, icon, text, modalData } =
    !isNiumForexUser &&
    is_recurring &&
    getData(status_code, recurringSavedAmount, destination_currency);
  const isBankMethod =
    BANK_METHODS.includes(instarem_bank_account_code) ||
    instarem_bank_account_display_name?.toUpperCase() === BANK_TRANSFER;
  const instaremBankAccountDispName = instarem_bank_account_display_name?.toUpperCase();
  return (
    <div
      key={row}
      className={`row ${isExpanded ? 'highlighted' : isHelpCenterFlag ? 'help-centre-hover' : ''}`}
      ref={!isExpanded ? context.setEmptyHeight : null}
      onClick={() => {
        if (isHelpCenterFlag) {
          handleRowSelected(item, context);
        }
      }}
    >
      {rowTemplate.map(({ value, className }, index) => {
        switch (value) {
          case 'details':
            return !isHelpCenterFlag ? (
              <div key={index} className={`column ${className}`}>
                <CommonButton
                  className={`detail-button${isExpanded ? ' expanded' : ''}`}
                  onClick={() => {
                    !isNiumForexUser &&
                      !hideTransferTracker &&
                      !isExpanded &&
                      context.getTransactionTimeline(transaction_id, transaction_number);
                    context.expandDetails(row);
                  }}
                  text="Details"
                  imgSrc={PINK_ARROW_ICON}
                  imgPosition="right"
                  width={117}
                  height={38}
                  borderRadius={4}
                  type="secondary"
                  fontSize={16}
                />
              </div>
            ) : null;

          default:
            return (
              <div
                key={index}
                className={`column ${className}`}
                onClick={() => {
                  !isNiumForexUser &&
                    !hideTransferTracker &&
                    !isExpanded &&
                    !isHelpCenterFlag &&
                    context.getTransactionTimeline(transaction_id, transaction_number);
                  className === 'transaction-no' && !isHelpCenterFlag && context.expandDetails(row);
                }}
              >
                {setCharLimit(value)}
              </div>
            );
        }
      })}
      {isExpanded && (
        <div className="details" id={`transaction-${transaction_number}`}>
          {showDeemedPaidMessage && (
            <MessageBox>
              <img src={INFORMATION_ICON_BLACK_BOLD_ICON} alt="info-icon" width={24} />
              <span className="text">{DEEMED_PAID_SUB_STATUS_TEXT}</span>
            </MessageBox>
          )}
          {is_recurring && status_code === FAILED ? (
            <MessageBox error>
              <img src={INFORMATION_ICON_BLACK_BOLD_ICON} alt="idea-icon" width={24} />
              <span className="text">
                {compileTemplateNew(
                  eddaDetails?.status === FAILED
                    ? RECURRING_TRANSFER_DATA.linkedBankError
                    : RECURRING_TRANSFER_DATA.linkedBankExpireError,
                  { BANK_ACCOUNT_NUMBER }
                )}
              </span>
            </MessageBox>
          ) : (
            instarem_bank_account_display_name?.toUpperCase() === LINKED_BANK_ACCOUNT &&
            !is_recurring && (
              <MessageBox>
                <img src={HAND_ICON} alt="idea-icon" width={24} />
                <span className="text">{EGIRO_TEXT}</span>
              </MessageBox>
            )
          )}

          {instarem_bank_account_display_name?.toUpperCase() === PAY_TO && (
            <MessageBox
              error={mandateDetails?.status === FAILED || mandateDetails?.status === DELINKED}
            >
              <img src={INFORMATION_ICON_BLACK_BOLD_ICON} alt="idea-icon" width={24} />
              <span className="text">
                {mandateDetails?.status === FAILED
                  ? compileTemplateNew(PAYTO_TEXT.failedMessage, { PAY_TO_BANK_ACCOUNT_NUMBER })
                  : mandateDetails?.status === DELINKED
                  ? compileTemplateNew(PAYTO_TEXT.deLinkMessage, { PAY_TO_BANK_ACCOUNT_NUMBER })
                  : PAYTO_TEXT?.downloadMessage}
              </span>
            </MessageBox>
          )}
          {isNiumForexUser &&
            status_code === AWAITING_PAYMENT &&
            context.props.niumForexUserStatus !== APPROVED &&
            context.props.aadhar_status === VERIFIED &&
            context.props.pan_status === VERIFIED && (
              //Pending Video Verification
              <VideoVerificationContainer>
                <div className="firstColumn">
                  <div className="headerItem">
                    {TRANSACTION_HISTORY_CONST.videoVerification.header}
                  </div>
                  <div className="subHeader">
                    {TRANSACTION_HISTORY_CONST.videoVerification.subHeader}
                  </div>
                </div>
                <div className="secondColumn">
                  <CommonButton
                    text={TRANSACTION_HISTORY_CONST.videoVerification.buttonText}
                    onClick={() => context.handleNiumForexNavigation(transaction_id)}
                    width={265}
                    height={36}
                  />
                </div>
              </VideoVerificationContainer>
            )}
          {isNiumForexUser &&
            status_code === AWAITING_PAYMENT &&
            context.props.niumForexUserStatus === APPROVED && (
              //Video Verification completed
              <PaymentInfoContainer>
                <img src={INFORMATION_ICON_BLACK_BOLD_ICON} alt="Info Icon" />
                {TRANSACTION_HISTORY_CONST.paymentInfo}
              </PaymentInfoContainer>
            )}
          {detailTemplate.map(
            (
              {
                section,
                className,
                fields,
                additional_info,
                moreInfo = false,
                moreInfoContent,
                show = true
              },
              index
            ) =>
              show && (
                <div key={index} className={`section ${className}`}>
                  <div className="head">
                    {section}
                    {moreInfo && (
                      <Popup
                        trigger={
                          <img
                            alt="more-info"
                            src={INFO_TIMELINE_ICON}
                            className="more-info-icon"
                          />
                        }
                        content={moreInfoContent}
                        size="tiny"
                        position="top center"
                        wide={true}
                      />
                    )}
                    {additional_info && additional_info.is_partially_editable && (
                      <Link
                        to={ADD_PAYEE_URL}
                        state={{
                          beneficiary_id: additional_info.beneficiary_id,
                          is_completely_editable: additional_info.is_completely_editable,
                          is_partially_editable: additional_info.is_partially_editable,
                          bank_account_country_code: additional_info.bank_account_country_code,
                          currency_code: additional_info.currency_code
                        }}
                        onClick={() => context.handleEditClick(item)}
                      >
                        <img
                          className="edit-btn-img"
                          src={EDIT_ICON_MULTI_TXN_ICON}
                          alt="edit-btn"
                        />
                      </Link>
                    )}
                  </div>
                  {fields?.filter(Boolean).map(({ key, value, className }, i) => (
                    <div key={i} className={`key-value ${className}`}>
                      {key ? `${key}: ${value}` : value}
                    </div>
                  ))}
                  {section === Recipient_Cash_Pickup_Details && getCashTemplate(cashPickUpTemplate)}
                  {section === Recipient_Cash_Pickup_Details &&
                    additional_info &&
                    additional_info.isMoneyGram && (
                      <a
                        className={`link bank-reference`}
                        href="https://www.moneygram.com/mgo/us/en/locations"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Cash pickup partner location
                      </a>
                    )}
                </div>
              )
          )}
          {!isNiumForexUser &&
            isIndividual &&
            isBankMethod &&
            PAYMENT_NOT_RECEIVED_STATE.includes(status_code) && (
              <div className="section link-text">
                <a
                  className={`link`}
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    context.showTransferFundModal(transaction_number, isIndividual);
                  }}
                >
                  <span>Transfer funds now</span>
                </a>
              </div>
            )}
          {isNiumForexUser && status_code !== CANCELLED && (
            <div className="section link-text">
              <a
                className={`link`}
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  context.handlePaymentInstruction(item);
                }}
              >
                <span>Payment instructions</span>
              </a>
            </div>
          )}
          {status_code === AWAITING_PAYMENT &&
            instaremBankAccountDispName !== LINKED_BANK_ACCOUNT &&
            instaremBankAccountDispName !== PAY_TO && (
              <div className="section link-text">
                <a
                  className={`link`}
                  href="#!"
                  onClick={(e) => {
                    e.preventDefault();
                    context.cancelTransaction(transaction_id);
                  }}
                >
                  <img src={CANCEL_ICON} alt="cancel icon" className="cancel-icon" />
                  <span>Cancel</span>
                </a>
              </div>
            )}
          {context.props.country_code === 'IN' && !is_referral && (
            <div className="section link-text">
              <a
                className={`link a2-form`}
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  context.downloadReciept(
                    'transaction-history/a2-form-download',
                    {
                      transaction_id,
                      transaction_number
                    },
                    isNiumForexUser
                  );
                }}
                target="_blank"
                download
              >
                <img src={DOWNLOAD_RECEIPT_ICON} alt="download icon" className="download-icon" />
                <span>Download A2 form</span>
              </a>
            </div>
          )}
          {!isNiumForexUser && (
            <div className="section link-text">
              <a
                className={`link download-receipt`}
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  recurringButtonText
                    ? onRecurringTransferButtonClick(
                        context,
                        status_code,
                        modalData,
                        recurring_transfer_config_id,
                        recurring_transfer_id
                      )
                    : context.downloadReciept('transaction/download-transaction-receipt', {
                        transaction_number
                      });
                }}
                target="_blank"
                download
              >
                <img
                  src={icon ? icon : DOWNLOAD_RECEIPT_ICON}
                  alt="download icon"
                  className="download-icon"
                />
                <span>{recurringButtonText ? recurringButtonText : 'Download the receipt'}</span>
              </a>
            </div>
          )}

          {!isNiumForexUser && !timelineError && !hideTransferTracker && (
            <div
              className="section link-text transaction-timeline-link"
              onClick={() =>
                openTimelineModal(
                  context,
                  lastSelectedTransactionId,
                  transaction_id,
                  transaction_number,
                  timelineCMSLabels,
                  transactionSummary,
                  timelineData,
                  timeline,
                  false
                )
              }
            >
              <img src={SMALL_CALENDAR_PINK_ICON} alt="calendar icon" />
              <span>{timelineCMSLabels?.trackThisTransfer}</span>
            </div>
          )}
          {is_recurring && (
            <div className="section link-text exchange-rate-text">
              <div>
                <span className="text-exchange">{isRecurringTransferFlagEnabled && text}</span>
                <GreyBox>
                  <img src={MOBILE_ICON} alt="idea-icon" width={24} className="image-mobile" />
                  <span className="text">
                    {'To manage recurring transfers, go to your Instarem app.'}
                  </span>
                </GreyBox>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const handleRenderHeads = (heads, context) => {
  const isHelpCenterFlag = context?.props?.location?.pathname === HELP_CENTER;
  return (
    <div className="header">
      {heads.map(({ content, className }, index) => {
        if (content === 'Details' && isHelpCenterFlag) {
          return null;
        }
        return (
          <div key={index} className={`head ${className}`}>
            {content}
          </div>
        );
      })}
    </div>
  );
};

//For Web view
export const individualDesktopTabularView = (context, heads) => {
  const countryCode = context && context.props && context.props.country_code;
  const isIndividual = get(context, 'props.account_type', '') === INDIVIDUAL;
  const { isNiumForexUser } = context.props;
  return (
    <div className="table">
      <PaginatedList
        key={'paginate'}
        className="desktop-list-wrapper"
        pageSize={TRANSACTION_HISTORY_PAGE_SIZE.desktop}
        isTransactionHistory={true}
        isIndividual={isIndividual}
        displayNote={countryCode !== 'US'}
        data={context.state.transactionHistory}
        renderEmpty={<div className="none">None</div>}
        renderPagination={context.renderPagination}
        isNiumForexUser={isNiumForexUser}
        fetchEntries={context.fetchTransactions}
        totalEntries={context.state.totalTransactions || 0}
        renderHeader={() => handleRenderHeads(heads, context)}
        renderItem={(item, row) => handleRenderItem(context, item, row)}
        searchFilter={context.state.searchFilter}
      />
    </div>
  );
};

const setCharLimit = (value) => {
  if (typeof value === 'string' && value && value.length > 20) {
    const shortValue = value.slice(0, 20);
    return <>{`${shortValue}`}...</>;
  } else {
    return value;
  }
};
export const individualDesktopListView = (context, DETAIL) => {
  const countryCode = context && context.props && context.props.country_code;
  const { isNiumForexUser } = context?.props || '';
  const isIndividual = get(context, 'props.account_type', '') === INDIVIDUAL;
  const {
    timelineData,
    timelineCMSLabels,
    transactionSummary,
    timelineError,
    isRecurringTransferFlagEnabled
  } = context.state;

  const timeline = processTimelineData(timelineData?.timeline || []);
  const eddaDetails = transactionSummary?.eddaDetails;
  const BANK_ACCOUNT_NUMBER = eddaDetails?.bankAccountNumber?.substr(
    eddaDetails?.bankAccountNumber?.length - 5
  );
  const mandateDetails = transactionSummary?.mandateDetails;
  const PAY_TO_BANK_ACCOUNT_NUMBER = mandateDetails?.accountNumber?.substr(
    eddaDetails?.bankAccountNumber.length - 5
  );

  return (
    <div className="cards">
      <PaginatedList
        className="mobile-list-wrapper"
        pageSize={TRANSACTION_HISTORY_PAGE_SIZE.mobile}
        isTransactionHistory={true}
        isNiumForexUser={isNiumForexUser}
        isIndividual={isIndividual}
        displayNote={countryCode !== 'US'}
        data={context.state.transactionHistory}
        renderEmpty={<div className="none">None</div>}
        renderPagination={context.renderPagination}
        fetchEntries={context.fetchTransactions}
        totalEntries={context.state.totalTransactions || 0}
        searchFilter={context.state.searchFilter}
        renderItem={(item, row) => {
          if (!item)
            return (
              <div key={row} style={{ height: context.state.emptyHeight }}>
                &nbsp;
              </div>
            );
          const {
            full_name,
            transaction_number,
            transaction_id = '#',
            company_name,
            account_type: item_account_type,
            status_code,
            instarem_bank_account_display_name,
            is_recurring = false,
            recurring_transfer_config_id,
            recurring_transfer_id,
            destination_currency,
            recurringSavedAmount,
            is_referral,
            pp_transaction_sub_status
          } = item;
          const { cardTemplate, modalTemplate, cashPickUpTemplate } = context.getMobileTemplate({
            item,
            transactionSummary,
            country_code: context.props.country_code,
            account_type: context.props.account_type
          });
          const showDeemedPaidMessage =
            status_code === PAID &&
            (pp_transaction_sub_status === PROCESSED_BY_CLEARING ||
              pp_transaction_sub_status === SENT_TO_BENEFICIARY_BANK);
          const hideTransferTracker =
            TRANSACTION_FINAL_STATES.includes(status_code) && !showDeemedPaidMessage;
          const isHelpCenterRoute = context?.props?.location?.pathname === HELP_CENTER;
          const { recurringButtonText, icon, text, modalData } =
            !isNiumForexUser &&
            is_recurring &&
            getData(status_code, recurringSavedAmount, destination_currency);
          const instaremBankAccountDispName = instarem_bank_account_display_name?.toUpperCase();

          return (
            <div
              key={row}
              className="card"
              ref={context.setEmptyHeight}
              onClick={() => handleRowSelected(item, context)}
            >
              <div className="name">
                {item_account_type === 'CORPORATE' ? company_name : full_name}
              </div>
              {cardTemplate.map(({ key, value, className }, index) => (
                <div
                  className={`wrapper ${className}`}
                  key={index}
                  id={`transaction-${transaction_number}`}
                >
                  <div className="head">{key}</div>
                  <div className="value">{value}</div>
                </div>
              ))}
              {isHelpCenterRoute ? (
                <CommonButton
                  onClick={() => {
                    !isNiumForexUser &&
                      !hideTransferTracker &&
                      context.getTransactionTimeline(transaction_id, transaction_number);
                  }}
                  text="Select"
                  width={122}
                  height={38}
                  type="secondary"
                />
              ) : (
                <Modal
                  style={{ marginTop: 'initial', width: '90%' }}
                  open={
                    context.state.modal === `${DETAIL}-${row}` ||
                    (transaction_number && transaction_number === context.state.selectedParamItem)
                  }
                  onOpen={context.openModal(DETAIL, row)}
                  onClose={context.closeModal}
                  trigger={
                    <div className="secondaryDetailButtonWrapper">
                      <CommonButton
                        onClick={() => {
                          !isNiumForexUser &&
                            !hideTransferTracker &&
                            context.getTransactionTimeline(transaction_id, transaction_number);
                          context.expandDetails(row);
                        }}
                        text="Details"
                        width={122}
                        height={38}
                        type="secondary"
                      />
                    </div>
                  }
                >
                  <div className="wrapper transaction">
                    <div className="title">
                      {item_account_type === 'CORPORATE' ? company_name : full_name}
                    </div>
                    <img src={CLOSE} alt="close" className="close" onClick={context.closeModal} />

                    {isNiumForexUser &&
                      status_code === AWAITING_PAYMENT &&
                      context.props.niumForexUserStatus !== APPROVED &&
                      context.props.aadhar_status === VERIFIED &&
                      context.props.pan_status === VERIFIED && (
                        <VideoVerificationContainer>
                          <div className="firstColumn">
                            <div className="headerItem">
                              {TRANSACTION_HISTORY_CONST.videoVerification.header}
                            </div>
                            <div className="subHeader">
                              {TRANSACTION_HISTORY_CONST.videoVerification.subHeader}
                            </div>
                          </div>
                          <div className="secondColumn">
                            <CommonButton
                              text={TRANSACTION_HISTORY_CONST.videoVerification.buttonText}
                              onClick={() => context.handleNiumForexNavigation(transaction_id)}
                              width={265}
                              height={36}
                            />
                          </div>
                        </VideoVerificationContainer>
                      )}
                    {isNiumForexUser &&
                      status_code === AWAITING_PAYMENT &&
                      context.props.niumForexUserStatus === APPROVED && (
                        <PaymentInfoContainer>
                          <img src={INFORMATION_ICON_BLACK_BOLD_ICON} alt="Info Icon" />

                          {TRANSACTION_HISTORY_CONST.paymentInfo}
                        </PaymentInfoContainer>
                      )}
                    {is_recurring && status_code === FAILED ? (
                      <MessageBox error>
                        <img src={INFORMATION_ICON_BLACK_BOLD_ICON} alt="idea-icon" width={24} />
                        <span className="text">
                          {compileTemplateNew(
                            eddaDetails?.status === FAILED
                              ? RECURRING_TRANSFER_DATA.linkedBankError
                              : RECURRING_TRANSFER_DATA.linkedBankExpireError,
                            { BANK_ACCOUNT_NUMBER }
                          )}
                        </span>
                      </MessageBox>
                    ) : (
                      instaremBankAccountDispName === LINKED_BANK_ACCOUNT &&
                      !is_recurring && (
                        <MessageBox>
                          <img src={HAND_ICON} alt="idea-icon" width={24} />
                          <span className="text">{EGIRO_TEXT}</span>
                        </MessageBox>
                      )
                    )}
                    {instarem_bank_account_display_name?.toUpperCase() === PAY_TO && (
                      <MessageBox
                        error={
                          mandateDetails?.status === FAILED || mandateDetails?.status === DELINKED
                        }
                      >
                        <img src={INFORMATION_ICON_BLACK_BOLD_ICON} alt="idea-icon" width={24} />
                        <span className="text">
                          {mandateDetails?.status === FAILED
                            ? compileTemplateNew(PAYTO_TEXT.failedMessage, {
                                PAY_TO_BANK_ACCOUNT_NUMBER
                              })
                            : mandateDetails?.status === DELINKED
                            ? compileTemplateNew(PAYTO_TEXT.deLinkMessage, {
                                PAY_TO_BANK_ACCOUNT_NUMBER
                              })
                            : PAYTO_TEXT?.downloadMessage}
                        </span>
                      </MessageBox>
                    )}
                    <div className="scrollable">
                      {showDeemedPaidMessage && (
                        <MessageBox>
                          <img src={INFORMATION_ICON_BLACK_BOLD_ICON} alt="info-icon" width={24} />
                          <span className="text">{DEEMED_PAID_SUB_STATUS_TEXT}</span>
                        </MessageBox>
                      )}
                      {modalTemplate.reduce(
                        (
                          acc,
                          { section, fields, className, moreInfoContent, show = true },
                          index
                        ) => {
                          return acc.concat([
                            show && (
                              <div key={`0-${index}`} className={`section ${className}`}>
                                {section}
                              </div>
                            ),
                            <div
                              key={`1-${index}`}
                              className={`fields ${className} ${
                                index === 5 ? 'download_screen' : ''
                              } `}
                            >
                              {fields
                                .filter(Boolean)
                                .map(({ key, value, className, isMoneyGram }, index) => {
                                  if (value === null || value === undefined) {
                                    switch (key) {
                                      case 'download-receipt':
                                        return (
                                          <div className="trans_history_options">
                                            {isNiumForexUser && status_code !== CANCELLED && (
                                              <div className="section link-text">
                                                <a
                                                  className={`link`}
                                                  href="#!"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    context.closeModal();
                                                    context.handlePaymentInstruction(item);
                                                  }}
                                                >
                                                  <span>Payment instructions</span>
                                                </a>
                                              </div>
                                            )}
                                            {status_code === AWAITING_PAYMENT &&
                                              instaremBankAccountDispName !== LINKED_BANK_ACCOUNT &&
                                              instaremBankAccountDispName !== PAY_TO && (
                                                <div className="section link-text">
                                                  <a
                                                    className={`link`}
                                                    href="#!"
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      context.closeModal();
                                                      context.cancelTransaction(transaction_id);
                                                    }}
                                                  >
                                                    <img
                                                      src={CANCEL_ICON}
                                                      alt="cancel icon"
                                                      className="cancel-icon"
                                                    />
                                                    <span>Cancel</span>
                                                  </a>
                                                </div>
                                              )}

                                            {context.props.country_code === 'IN' &&
                                              !is_referral && (
                                                <div className="section link-text">
                                                  <a
                                                    key={index}
                                                    className={`link ${className}`}
                                                    href="#!"
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      context.downloadReciept(
                                                        'transaction-history/a2-form-download',
                                                        { transaction_id, transaction_number },
                                                        isNiumForexUser
                                                      );
                                                    }}
                                                    target="_blank"
                                                    download
                                                  >
                                                    <img
                                                      src={DOWNLOAD_RECEIPT_ICON}
                                                      alt="download icon"
                                                      className="download-icon"
                                                    />
                                                    <span>Download A2 Form</span>
                                                  </a>
                                                </div>
                                              )}
                                            {is_recurring && (
                                              <div>
                                                <span className="text-exchange">
                                                  {isRecurringTransferFlagEnabled && text}
                                                </span>
                                                <GreyBox>
                                                  <img
                                                    src={MOBILE_ICON}
                                                    alt="idea-icon"
                                                    width={24}
                                                    className="image-mobile"
                                                  />
                                                  <span className="text">
                                                    {
                                                      'To manage recurring transfers, go to your Instarem app.'
                                                    }
                                                  </span>
                                                </GreyBox>
                                              </div>
                                            )}

                                            {!isNiumForexUser && (
                                              <div className="section link-text">
                                                <a
                                                  key={index}
                                                  className={`link ${className}`}
                                                  href="#!"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    recurringButtonText && context.closeModal();
                                                    recurringButtonText
                                                      ? onRecurringTransferButtonClick(
                                                          context,
                                                          status_code,
                                                          modalData,
                                                          recurring_transfer_config_id,
                                                          recurring_transfer_id
                                                        )
                                                      : context.downloadReciept(
                                                          'transaction/download-transaction-receipt',
                                                          { transaction_number }
                                                        );
                                                  }}
                                                  target="_blank"
                                                  download
                                                >
                                                  <img
                                                    src={icon ? icon : DOWNLOAD_RECEIPT_ICON}
                                                    alt="download icon"
                                                    className="download-icon"
                                                  />
                                                  <span>
                                                    {recurringButtonText
                                                      ? recurringButtonText
                                                      : 'Receipt'}
                                                  </span>
                                                </a>
                                              </div>
                                            )}
                                          </div>
                                        );
                                      case 'instarem-bank-details':
                                        if (
                                          PAYMENT_NOT_RECEIVED_STATE.includes(status_code) &&
                                          !isNiumForexUser
                                        ) {
                                          return (
                                            <div
                                              key={index}
                                              className={`link ${className}`}
                                              onClick={() => {
                                                context.closeModal();
                                                context.showTransferFundModal(
                                                  transaction_number,
                                                  isIndividual
                                                );
                                              }}
                                            >
                                              {' '}
                                              Transfer funds now
                                            </div>
                                          );
                                        }
                                        return null;
                                      default:
                                        return null;
                                    }
                                  }
                                  return (
                                    show && (
                                      <>
                                        <div key={index} className={`key-value ${className}`}>
                                          {key ? `${key}: ${value}` : value}
                                        </div>
                                        {moreInfoContent && (
                                          <div className={`key-value ${className}`}>
                                            {moreInfoContent}
                                          </div>
                                        )}
                                        {isMoneyGram && (
                                          <a
                                            className={`link bank-reference`}
                                            href="https://www.moneygram.com/mgo/us/en/locations"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            Cash pickup partner location
                                          </a>
                                        )}
                                      </>
                                    )
                                  );
                                })}
                              {section === Recipient_Cash_Pickup_Details &&
                                getCashTemplate(cashPickUpTemplate)}
                            </div>
                          ]);
                        },
                        []
                      )}
                      {!isNiumForexUser && !timelineError && !hideTransferTracker && (
                        <div
                          className="mobile-transaction-timeline-link"
                          onClick={() => {
                            context.closeModal();
                            openTransactionTimelineModal(
                              timelineData,
                              timeline,
                              timelineCMSLabels,
                              transactionSummary
                            );
                          }}
                        >
                          <span>
                            <img src={SMALL_CALENDAR_PINK_ICON} alt="calendar icon" />
                            {timelineCMSLabels?.trackThisTransfer}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </Modal>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};
const handleFilterApply = async (context, device) => {
  const statuses =
    context.state.searchFilter.status.length > 0
      ? JSON.stringify(context.state.searchFilter.status)
      : null;
  const {
    props: { activateLoader, disableLoader }
  } = context;
  const {
    searchFilter: { to, from, input }
  } = context.state;
  activateLoader();
  await context.fetchTransactions(null, 7, 0, to, from, input, statuses);
  context.setState({ [device === DEVICE_MOBILE ? 'modal' : 'filterModal']: null });
  disableLoader();
};

const handleDateFilterApply = (context, device) => {
  context.setState({ [device === DEVICE_MOBILE ? 'modal' : 'filterModal']: null });
  const { from, to } = context.state.searchFilter;
  context.setDateFilter({ from, to });
};

const handleOnDateChange = (value, context, source) => {
  context.setState((prevState) => ({
    ...prevState,
    searchFilter: {
      ...prevState.searchFilter,
      [source]: value ? moment(value) : null
    }
  }));
};

export const statusFilterView = (context, top, right) => {
  const { device, isNiumForexUser } = context.props,
    { searchFilter } = context.state;
  return (
    <div
      className="status-filter-modal"
      onClick={(e) => e.stopPropagation()}
      style={
        device === DEVICE_MOBILE ? null : { top: top + 10, right: window.innerWidth - right - 5 }
      }
    >
      <div className="title">Search by Status</div>
      <img
        src={CLOSE_HEAVY_ICON}
        alt="close"
        className="close"
        onClick={() =>
          context.setState({ [device === DEVICE_MOBILE ? 'modal' : 'filterModal']: null })
        }
      />
      <div className="status-filter">
        {TRANSACTION_FILTER_STATUS_CRITERIA.status.map(({ text, status_code }, index) => (
          <span
            key={index}
            onClick={context.toggleStatusFilter(status_code)}
            className={`filter-button${searchFilter.status.includes(status_code) ? ' active' : ''}`}
          >
            {text}
          </span>
        ))}
      </div>
      {!isNiumForexUser ? (
        <div className="return-filter">
          {TRANSACTION_FILTER_STATUS_CRITERIA.returns.map(({ status_code, text }, index) => (
            <span
              key={index}
              onClick={context.toggleStatusFilter(status_code)}
              className={`filter-button${
                searchFilter.status.includes(status_code) ? ' active' : ''
              }`}
            >
              {text}
            </span>
          ))}
        </div>
      ) : null}
      <CommonButton text="Apply" type="link" onClick={() => handleFilterApply(context, device)} />

      <CommonButton type="link" text="Reset" onClick={context.clearStatusFilter} />
    </div>
  );
};

export const dateFilterView = (context, top, right, from, to, DateSelector, ref) => {
  const { device } = context.props;
  const nextDate = moment(from).add(365, 'days');
  const currentDate = moment();
  let maxToDate = currentDate;
  if (nextDate.diff(currentDate, 'days') < 0) {
    maxToDate = nextDate;
  }
  const startDate = moment(to).subtract(365, 'days');
  return (
    <div
      className="date-filter-modal"
      onClick={(e) => e.stopPropagation()}
      style={
        device === DEVICE_MOBILE ? null : { top: top + 10, right: window.innerWidth - right - 5 }
      }
    >
      <div className="title">Sort by date</div>
      <img
        src={CLOSE_HEAVY_ICON}
        alt="close"
        className="close"
        onClick={() =>
          context.setState({ [device === DEVICE_MOBILE ? 'modal' : 'filterModal']: null })
        }
      />
      <DateSelector className="date-picker" clickable={!from}>
        <DatePicker
          maxDate={to ? to : moment()}
          value={from ? context.getLocaleDate(from) : ''}
          placeholderText="From date"
          dropdownMode="select"
          withPortal={!ref}
          readOnly={!ref}
          className="date-filter from"
          onChange={(e) => handleOnDateChange(e, context, 'from')}
          minDate={startDate}
        />
        <img
          className={`calender-icon${from ? ' close' : ''}`}
          alt="calender"
          src={!from ? TRANSACTION_SEARCH_CALENDER_LIGHT_ICON : CLOSE}
          onClick={() => handleOnDateChange(null, context, 'from')}
        />
      </DateSelector>
      <DateSelector className="date-picker" clickable={!to}>
        <DatePicker
          minDate={from}
          value={to ? context.getLocaleDate(to) : ''}
          placeholderText="To date"
          dropdownMode="select"
          withPortal={!ref}
          readOnly={!ref}
          className="date-filter to"
          onChange={(e) => handleOnDateChange(e, context, 'to')}
          maxDate={maxToDate}
        />
        <img
          className={`calender-icon${to ? ' close' : ''}`}
          alt="calender"
          src={!to ? TRANSACTION_SEARCH_CALENDER_LIGHT_ICON : CLOSE}
          onClick={(e) => {
            e.stopPropagation();
            handleOnDateChange(null, context, 'to');
          }}
        />
      </DateSelector>
      <CommonButton
        text="Apply"
        width={90}
        height={30}
        onClick={() => handleDateFilterApply(context, device)}
      />
      <CommonButton
        type="link"
        text="Reset"
        onClick={() =>
          context.setState((prevState) => ({
            ...prevState,
            searchFilter: {
              ...prevState.searchFilter,
              from: null,
              to: null
            }
          }))
        }
      />

      <div className="sub-title">Quick options</div>
      {TRANSACTION_FILTER_DATE_CRITERIA.map(({ label, className: _className, from, to }, index) => (
        <CommonButton
          text={label}
          type="link"
          key={index}
          onClick={() =>
            context.setState((prevState) => ({
              ...prevState,
              searchFilter: {
                ...prevState.searchFilter,
                from: from(),
                to: to()
              }
            }))
          }
        >
          {label}
        </CommonButton>
      ))}
    </div>
  );
};

export const corporateDesktopTabularView = (context, heads) => {
  const countryCode = context && context.props && context.props.country_code;

  return (
    <div className="table">
      <PaginatedList
        className="desktop-list-wrapper"
        pageSize={TRANSACTION_HISTORY_PAGE_SIZE.desktop}
        displayNote={countryCode !== 'US'}
        data={context.state.transactionHistory}
        renderEmpty={<div className="none">None</div>}
        renderPagination={context.renderPagination}
        fetchEntries={context.fetchTransactions}
        totalEntries={context.state.totalTransactions || 0}
        searchFilter={context.state.searchFilter}
        renderHeader={() => (
          <div className="header">
            {heads.map(({ content, className }, index) => (
              <div key={index} className={`head ${className}`}>
                {content}
              </div>
            ))}
          </div>
        )}
        renderItem={(mainItem, row) => {
          if (mainItem && mainItem.transactions) {
            return (
              <div
                className={`batch-row ${mainItem.batch_number ? 'with-batch' : ''} ${
                  mainItem.isExpanded ? 'expanded' : ''
                }`}
              >
                <div
                  className={`batch-section ${mainItem.isExpanded ? 'expanded' : ''}`}
                  onClick={() => context.expandDetails(row)}
                >
                  <span className={`section-no`}>
                    {mainItem.batch_number
                      ? `Batch No. ${mainItem.batch_number}`
                      : `Transaction No. ${mainItem.transaction_number}`}
                  </span>
                  <span className="horizontal-line"></span>
                  <span className="no-of-txn">{`with ${mainItem.transactions.length} Transactions`}</span>
                  <img
                    className={mainItem.isExpanded ? 'expanded' : ''}
                    src={DOWN_CHEVRON_LIGHT_ICON}
                    alt="more details"
                  />
                </div>
                {mainItem.transactions.map((item, transactionIndex) => {
                  const {
                    transaction_id,
                    transaction_number,
                    bank_reference_number,
                    isExpanded,
                    showRefInput,
                    is_referral
                  } = item;
                  //below needs to be fixed in more better way
                  if (!item)
                    return (
                      <div
                        key={row + transactionIndex}
                        className="empty-row"
                        style={{ height: context.state.emptyHeight }}
                      >
                        &nbsp;
                      </div>
                    );
                  const { rowTemplate, detailTemplate } = context.getDesktopTemplate({
                    item,
                    account_type: context.props.account_type
                  });
                  return (
                    mainItem.isExpanded && (
                      <div
                        key={row + transactionIndex}
                        className={`transaction-wrapper ${
                          !mainItem.batch_number ? 'without-batch' : ''
                        }`}
                      >
                        <div
                          key={row + transactionIndex}
                          className={`row ${isExpanded ? 'highlighted' : ''}`}
                          ref={!isExpanded ? context.setEmptyHeight : null}
                        >
                          {rowTemplate.map(({ value, className }, index) => {
                            switch (value) {
                              case 'details':
                                return (
                                  <div className={`column ${className}`}>
                                    <CommonButton
                                      className={`detail-button ${isExpanded ? 'expanded' : ''}`}
                                      width={100}
                                      imgSrc={PINK_ARROW_ICON}
                                      imgPosition="right"
                                      height={38}
                                      type="secondary"
                                      text="Details"
                                      key={index}
                                      onClick={() => context.expandDetails(row, transactionIndex)}
                                    />
                                  </div>
                                );

                              default:
                                return (
                                  <div
                                    key={index}
                                    className={`column ${className}`}
                                    onClick={
                                      className === 'transaction-no'
                                        ? () => context.expandDetails(row, transactionIndex)
                                        : null
                                    }
                                  >
                                    {value}
                                  </div>
                                );
                            }
                          })}
                          {isExpanded && (
                            <div className="details">
                              {detailTemplate.map(
                                (
                                  {
                                    section,
                                    className,
                                    fields,
                                    additional_info,
                                    moreInfo = false,
                                    moreInfoContent,
                                    show = true
                                  },
                                  index
                                ) =>
                                  show && (
                                    <div key={index} className={`section ${className}`}>
                                      <div className="head">
                                        {section}
                                        {moreInfo && (
                                          <Popup
                                            trigger={
                                              <img
                                                alt="more-info"
                                                src={INFO_TIMELINE_ICON}
                                                className="info-icon"
                                              />
                                            }
                                            content={moreInfoContent}
                                            size="tiny"
                                            position="top center"
                                            wide={true}
                                          />
                                        )}
                                        {additional_info &&
                                          additional_info.is_partially_editable && (
                                            <Link
                                              to={ADD_PAYEE_URL}
                                              state={{
                                                beneficiary_id: additional_info.beneficiary_id,
                                                is_completely_editable:
                                                  additional_info.is_completely_editable,
                                                is_partially_editable:
                                                  additional_info.is_partially_editable
                                              }}
                                              onClick={() => context.handleEditClick(item)}
                                            >
                                              <img
                                                className="edit-btn-img"
                                                src={EDIT_ICON_MULTI_TXN_ICON}
                                                alt="edit-btn"
                                              />
                                            </Link>
                                          )}
                                      </div>
                                      {fields.map(({ key, value, className }, i) => (
                                        <div key={i} className={`key-value ${className}`}>
                                          {key ? `${key}: ${value}` : value}
                                        </div>
                                      ))}
                                    </div>
                                  )
                              )}
                              {!bank_reference_number &&
                                (showRefInput === null ? (
                                  <div
                                    className={`link bank-reference`}
                                    onClick={context.showRefInput(row, transactionIndex)}
                                  >
                                    <img src={NEW_ADD_REF_ICON} alt="add-ref" />
                                    Add bank ref.
                                  </div>
                                ) : (
                                  <div className="link ref-input">
                                    <Input
                                      focus={true}
                                      placeholder="Bank ref."
                                      action={{
                                        icon: 'checkmark',
                                        onClick: context.saveBankRef(
                                          transaction_id,
                                          showRefInput,
                                          row,
                                          transactionIndex
                                        )
                                      }}
                                      value={showRefInput}
                                      onChange={context.onRefInputChange(row, transactionIndex)}
                                    />
                                    <img
                                      src={CLOSE_HEAVY_ICON}
                                      alt="close"
                                      className="close"
                                      onClick={context.hideRefInput(row, transactionIndex)}
                                    />
                                  </div>
                                ))}
                              {context.props.country_code === 'IN' && !is_referral && (
                                <a
                                  className={`link a2-form`}
                                  href="#!"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    context.downloadReciept(
                                      'transaction-history/a2-form-download',
                                      {
                                        transaction_id,
                                        transaction_number,
                                        batch_number: mainItem.batch_number
                                      }
                                    );
                                  }}
                                  target="_blank"
                                  download
                                >
                                  <img
                                    src={DOWNLOAD_RECEIPT_ICON}
                                    alt="download icon"
                                    className="download-icon"
                                  />
                                  <span>Download A2 form</span>
                                </a>
                              )}
                              <a
                                className={`link download-receipt`}
                                href="#!"
                                onClick={(e) => {
                                  e.preventDefault();
                                  context.downloadReciept(
                                    'transaction/download-transaction-receipt',
                                    { transaction_number, batch_number: mainItem.batch_number }
                                  );
                                }}
                                target="_blank"
                                download
                              >
                                <img
                                  src={DOWNLOAD_RECEIPT_ICON}
                                  alt="download icon"
                                  className="download-icon"
                                />
                                <span>Download the receipt</span>
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    )
                  );
                })}
              </div>
            );
          }
        }}
      />
    </div>
  );
};

export const corporateDesktopListView = (context, DETAIL) => {
  const countryCode = context && context.props && context.props.country_code;

  return (
    <div className="cards">
      <PaginatedList
        className="mobile-list-wrapper"
        pageSize={TRANSACTION_HISTORY_PAGE_SIZE.mobile}
        displayNote={countryCode !== 'US'}
        data={context.state.transactionHistory}
        renderEmpty={<div className="none">None</div>}
        renderPagination={context.renderPagination}
        fetchEntries={context.fetchTransactions}
        totalEntries={context.state.totalTransactions || 0}
        searchFilter={context.state.searchFilter}
        renderItem={(mainItem, row) => {
          if (mainItem && mainItem.transactions) {
            return (
              <div
                className={`batch-row ${mainItem.batch_number ? 'with-batch' : ''} ${
                  mainItem.isExpanded ? 'expanded' : ''
                }`}
              >
                <div
                  className={`batch-section ${mainItem.isExpanded ? 'expanded' : ''}`}
                  onClick={() => context.expandDetails(row)}
                >
                  <span className={`section-no`}>
                    {mainItem.batch_number
                      ? `Batch No. ${mainItem.batch_number}`
                      : `Transaction No. ${mainItem.transaction_number}`}
                  </span>
                  <span className="horizontal-line"></span>
                  <span className="no-of-txn">{`with ${mainItem.transactions.length} Transactions`}</span>
                  <img
                    className={mainItem.isExpanded ? 'expanded' : ''}
                    src={DOWN_CHEVRON_LIGHT_ICON}
                    alt="more details"
                  />
                </div>
                {mainItem.transactions.map((item, transactionIndex) => {
                  const {
                    full_name,
                    transaction_number,
                    transaction_id = '#',
                    showRefInput,
                    company_name,
                    bank_reference_number,
                    account_type: item_account_type
                  } = item;
                  const { cardTemplate, modalTemplate } = context.getMobileTemplate({
                    item,
                    country_code: context.props.country_code,
                    account_type: context.props.account_type
                  });
                  if (!item)
                    return (
                      <div
                        key={row + transactionIndex}
                        style={{ height: context.state.emptyHeight }}
                      >
                        &nbsp;
                      </div>
                    );
                  return (
                    mainItem.isExpanded && (
                      <div
                        key={row + transactionIndex}
                        className="card"
                        ref={context.setEmptyHeight}
                      >
                        <div className="name">
                          {item_account_type === 'CORPORATE' ? company_name : full_name}
                        </div>
                        {cardTemplate.map(({ key, value, className }, index) => (
                          <div
                            className={`wrapper ${className}`}
                            key={index + row + transactionIndex}
                          >
                            <div className="head">{key}</div>
                            <div className="value">{value}</div>
                          </div>
                        ))}
                        <Modal
                          style={{ marginTop: 'initial' }}
                          open={context.state.modal === `${row}-${transactionIndex}`}
                          onOpen={context.openModal(DETAIL, row, transactionIndex)}
                          onClose={context.closeModal}
                          trigger={<div className="detail-button">Details</div>}
                        >
                          <div className="wrapper transaction">
                            <div className="title">
                              {item_account_type === 'CORPORATE' ? company_name : full_name}
                            </div>
                            <img
                              src={CLOSE}
                              alt="close"
                              className="close"
                              onClick={() => context.setState({ modal: -1 })}
                            />
                            <div className="scrollable">
                              {modalTemplate.reduce(
                                (
                                  acc,
                                  { section, fields, className, moreInfoContent, show = true },
                                  index
                                ) => {
                                  return acc.concat([
                                    <div key={`0-${index}`} className={`section ${className}`}>
                                      {section}
                                    </div>,
                                    <div key={`1-${index}`} className={`fields ${className}`}>
                                      {fields
                                        .filter(Boolean)
                                        .map(({ key, value, className }, index) => {
                                          if (value === null || value === undefined) {
                                            switch (key) {
                                              case 'download-receipt':
                                                return (
                                                  <a
                                                    key={index}
                                                    className={`link ${className}`}
                                                    href="#!"
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      context.downloadReciept(
                                                        'transaction/download-transaction-receipt',
                                                        {
                                                          transaction_number,
                                                          batch_number: mainItem.batch_number
                                                        }
                                                      );
                                                    }}
                                                    target="_blank"
                                                    download
                                                  >
                                                    <img
                                                      src={DOWNLOAD_RECEIPT_ICON}
                                                      alt="download icon"
                                                      className="download-icon"
                                                    />
                                                    <span>Download the receipt</span>
                                                  </a>
                                                );
                                              case 'a2-form':
                                                return (
                                                  <a
                                                    key={index}
                                                    className={`link ${className}`}
                                                    href="#!"
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      context.downloadReciept(
                                                        'transaction-history/a2-form-download',
                                                        { transaction_id, transaction_number }
                                                      );
                                                    }}
                                                    target="_blank"
                                                    download
                                                  >
                                                    <img
                                                      src={DOWNLOAD_RECEIPT_ICON}
                                                      alt="download icon"
                                                      className="download-icon"
                                                    />
                                                    <span>Download A2 form</span>
                                                  </a>
                                                );
                                              case 'bank-reference':
                                                return bank_reference_number ? null : showRefInput ===
                                                  null ? (
                                                  <div
                                                    key={index}
                                                    className={`link ${className}`}
                                                    onClick={context.showRefInput(
                                                      row,
                                                      transactionIndex
                                                    )}
                                                  >
                                                    <img src={NEW_ADD_REF_ICON} alt="add-ref" />
                                                    Add bank ref.
                                                  </div>
                                                ) : (
                                                  <div key={index} className="link ref-input">
                                                    <Input
                                                      placeholder="Bank ref."
                                                      action={{
                                                        icon: 'checkmark',
                                                        onClick: context.saveBankRef(
                                                          transaction_id,
                                                          showRefInput,
                                                          row,
                                                          transactionIndex
                                                        )
                                                      }}
                                                      value={showRefInput}
                                                      onChange={context.onRefInputChange(
                                                        row,
                                                        transactionIndex
                                                      )}
                                                    />
                                                    <img
                                                      src={CLOSE_HEAVY_ICON}
                                                      alt="close"
                                                      className="close"
                                                      onClick={context.hideRefInput(
                                                        row,
                                                        transactionIndex
                                                      )}
                                                    />
                                                  </div>
                                                );
                                              default:
                                                return null;
                                            }
                                          }
                                          return (
                                            show && (
                                              <>
                                                <div
                                                  key={index}
                                                  className={`key-value ${className}`}
                                                >
                                                  {key ? `${key}: ${value}` : value}
                                                </div>
                                                {moreInfoContent && <div>{moreInfoContent}</div>}
                                              </>
                                            )
                                          );
                                        })}
                                    </div>
                                  ]);
                                },
                                []
                              )}
                            </div>
                          </div>
                        </Modal>
                      </div>
                    )
                  );
                })}
              </div>
            );
          }
        }}
      />
    </div>
  );
};
